module.exports = "<div>\n  <label for=\"{{id}}\" class=\"control-label\" ng-if=\"to.label\">\n    {{to.label}}\n    {{to.required ? '*' : ''}}\n  </label>\n  <formly-transclude></formly-transclude>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wrappers/label.html
 ** module id = 19
 ** module chunks = 0
 **/